import TagManager from "react-gtm-module";
import { useNavigate } from "react-router-dom";
import { dataLayerHelper } from "../data/dataLayerModel";

export default function Header(props: any) {

    const history = useNavigate();

    const actives = [];
    const inactives = [];

    let x, y;
    for (x = 0; x < props.step; ++x) {
        actives.push(<span className="active" key={x}></span>);
    }

    for (y = x; y < props.total; ++y) {
        inactives.push(<span key={y}></span>);
    }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    function backTo(previous: string) {
        TagManager.dataLayer(dataLayerHelper.measureClick('voltar', document.location.hash.substring(2)));

        if ( previous==="#" )
            history(-1);
        else
            document.location = previous;
    }

    return (
        <>
            <header className="header-curriculum">
                <div className="container">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <div onClick={() => backTo(props.previous) } className={`header-curriculum-back ${props.previous==='' ? 'd-none' : ''}`}>
                                <img src="images/ico-arrow-left.svg" alt="Voltar" />
                            </div>
                            <p className="text-center">{props.title}</p>
                            {
                                props.finished &&
                                <img src="images/ico-concluded.svg" alt="Cadastro Finalizado" className="header-curriculum-finished"></img>
                            }
                        </div>
                    </div>
                </div>
                <div className="header-curriculum-steps d-flex align-items-end justify-content-between">
                    {actives}
                    {inactives}
                </div>
            </header>
        </>);
}
